import { IWantEntry, IWantProductEntry, IWantProductTemplateEntry } from 'wants/types/WantEntry';

export const isWantProductEntry = (wantEntry: IWantEntry): wantEntry is IWantProductEntry =>
  'productId' in wantEntry;

export const isWantProductTemplateEntry = (
  wantEntry: IWantEntry,
): wantEntry is IWantProductTemplateEntry => 'productTemplateId' in wantEntry;
